import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ApplicantFieldValue, SaveResponse } from "../interfaces/form-model";

@Injectable({
  providedIn: 'root'
})
export class FormApplicantService {

  constructor(private http: HttpClient) { }

  createApplicant(applicant: Partial<ApplicantFieldValue>, formUuId: string) {
    return this.http.post<SaveResponse>(`${window.location.origin}/ui-forms/v1/form/submit/${formUuId}/applicant`, applicant);
  }

  deleteApplicant(formUuId: string, applicantId: number) {
    return this.http.delete<SaveResponse>(`${window.location.origin}/ui-forms/v1/form/submit/${formUuId}/applicant/${applicantId}`);
  }

  linkApplicant(formUuId: string, applicantId: number) {
    return this.http.put<SaveResponse>(`${window.location.origin}/ui-forms/v1/form/submit/${formUuId}/applicant/${applicantId}/link`, {});
  }
}
